import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
var SCOPES_API_URL = 'scopes/v1';
export var getFetchProductPermissions = function getFetchProductPermissions(makeRequest) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(productIds, cloudId, experience) {
      var productParams, params, path, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(productIds.length === 0)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", Promise.resolve(new Map()));
          case 2:
            _context.prev = 2;
            productParams = productIds.map(function (productId) {
              return ['productId', productId];
            });
            params = new URLSearchParams([['experience', experience]].concat(_toConsumableArray(productParams)));
            path = "".concat(SCOPES_API_URL, "/").concat(cloudId, "?").concat(params.toString());
            _context.next = 8;
            return makeRequest(path);
          case 8:
            response = _context.sent;
            return _context.abrupt("return", new Map(Object.keys(response.products).map(function (product) {
              return [product, response.products[product]];
            })));
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](2);
            return _context.abrupt("return", new Map());
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 12]]);
    }));
    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
};